const hash = window.location.hash;
const loginForm = document.getElementById("LoginFormWrapper");
const recoverForm = document.getElementById("RecoverPasswordFormWrapper");

if (hash === "#recover") {
  // パスワードリセットフォーム表示
  if (loginForm) loginForm.style.display = "none";
  if (recoverForm) recoverForm.style.display = "block";
} else {
  // デフォルト（ログインフォーム表示）
  if (loginForm) loginForm.style.display = "block";
  if (recoverForm) recoverForm.style.display = "none";
}

// 「パスワードを忘れた方」のリンククリック時に切り替える
const resetPassword = document.querySelector("a[href='#recover']");
if (resetPassword) {
  resetPassword.addEventListener("click", function (e) {
    e.preventDefault();
    if (loginForm) loginForm.style.display = "none";
    if (recoverForm) recoverForm.style.display = "block";
    history.replaceState(null, null, " "); // アンカーを削除
  });
}

// 「ログインに戻る」リンククリック時の動作
const backToLogin = document.querySelector("a[href='#login']");
if (backToLogin) {
  backToLogin.addEventListener("click", function (e) {
    e.preventDefault();
    if (loginForm) loginForm.style.display = "block";
    if (recoverForm) recoverForm.style.display = "none";
    history.replaceState(null, null, " "); // アンカーを削除
  });
}
